<template>
  <v-app-bar color="primary" density="compact">
    <v-app-bar-title>Le Coq Manu</v-app-bar-title>

    <template #append>
      <v-menu v-if="auth.user" location="bottom end">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            variant="text"
            prepend-icon="mdi-account-circle"
            size="small"
          >
            {{ auth.user.email }}
          </v-btn>
        </template>

        <v-list density="compact" min-width="190">
          <v-list-item
            prepend-icon="mdi-credit-card-outline"
            title="Mes cartes"
            to="/cartes"
          />
          <v-list-item
            :prepend-icon="isDark ? 'mdi-white-balance-sunny' : 'mdi-weather-night'"
            :title="isDark ? 'Thème clair' : 'Thème sombre'"
            @click="toggleTheme"
          />
          <v-list-item
            prepend-icon="mdi-logout"
            title="Se déconnecter"
            @click="handleLogout"
          />
        </v-list>
      </v-menu>
    </template>
  </v-app-bar>

  <v-main class="pb-14">
    <router-view />
  </v-main>

  <v-bottom-navigation :model-value="currentTab" color="primary" grow>
    <v-btn to="/" value="search" exact>
      <v-icon>mdi-magnify</v-icon>
      <span>Recherche</span>
    </v-btn>
    <v-btn to="/scanner" value="scanner">
      <v-icon>mdi-barcode-scan</v-icon>
      <span>Scanner</span>
    </v-btn>
    <v-btn to="/achats" value="achats">
      <v-icon>mdi-receipt-text-check-outline</v-icon>
      <span>Achats</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTheme } from 'vuetify'
import { useAuthStore } from '../stores/auth'

export default defineComponent({
  name: 'AppLayout',

  setup() {
    const route  = useRoute()
    const router = useRouter()
    const auth   = useAuthStore()
    const theme  = useTheme()

    const currentTab = computed(() =>
      route.name === 'scanner' ? 'scanner'
        : route.name === 'achats' ? 'achats'
        : route.name === 'cartes' ? ''
        : 'search'
    )

    const isDark = computed(() => theme.name.value === 'lecoqDark')

    function toggleTheme(): void {
      theme.toggle(['lecoq', 'lecoqDark'])
    }

    async function handleLogout(): Promise<void> {
      await auth.logout()
      router.push({ name: 'login' })
    }

    return { auth, currentTab, isDark, toggleTheme, handleLogout }
  },
})
</script>
